// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2i5WU","detailsBorder":"styles_detailsBorder__1xwNt"};